<template>
    <div class="wrap">
        <div class="listContain3">
          <div class="searchContent">
            <div class="oildataPicker">
              <span class="name">日期</span>
              <el-date-picker
                  v-model="value1"
                  type="daterange"
                  unlink-panels
                  style="margin-left: 10px; margin-right: 10px"
                  start-placeholder="选择开始日期"
                  end-placeholder="选择结束日期"
                  value-format="yyyy-MM-dd"
                  :picker-options="pickerOptions">
              </el-date-picker>
            </div>
            <span class="searchInputText">报警内容</span>
            <el-input placeholder="请输入报警内容" v-model="maintaiSearch"></el-input>
            <el-button  type="danger" @click="doSearch">查找</el-button>
            <el-button type="info" plain @click="reset">重置</el-button>
          </div>
          <div class="tablelistBody">
            <el-table
              :data="dataList"
              style="width: 100%;"
              size="medium"
              height= '598px'
              v-loading="listLoading"
            >
              <el-table-column prop="order" label="序号" min-width="3.773585%"></el-table-column>
              <el-table-column prop="warnCont" label="报警内容" min-width="9.703504%"></el-table-column>
              <el-table-column prop="startTime" label="开始报警时间" min-width="13.477089%"></el-table-column>
              <el-table-column prop="endTime" label="解除报警时间" min-width="13.477089%">
                <template slot-scope="scope">
                  <div @click="downAlarm(scope.row.id)" class="alarmBtn" v-if="scope.row.endTime == ''&& scope.row.alarmId == '40000000'">完成保养</div>
                  <div v-else>{{scope.row.endTime}}</div>
                </template>
              </el-table-column>
              <el-table-column prop="duration" label="报警持续时长(H)" min-width="6.469002%"></el-table-column>
              <el-table-column prop="location" label="报警地点" min-width="15.094339%"></el-table-column>
              <el-table-column prop="gps" label="报警GPS坐标" min-width="9.703504%"></el-table-column>
              <el-table-column prop="status" label="报警时设备状态" min-width="7.547169%">
                  <template slot-scope="scope">
                    <span class="wordStatus_1" v-if="scope.row.status == 0"
                      >离线</span
                    >
                    <span class="wordStatus_2" v-if="scope.row.status == 1"
                      >怠速</span
                    >
                    <span class="wordStatus_3" v-if="scope.row.status == 2"
                      >作业中</span
                    >
                  </template>
              </el-table-column>
              <el-table-column label="操作" min-width="7.547169%">
                  <template slot-scope="scope">
                    <div class="analysis" v-if="hasOperater(scope.row.warnCont)" @click="analysis(scope.row)"
                      >报警分析</div
                    >
                  </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="pageblock">
            <el-pageCover
              class="pageBlock"
              :pageMsg="pageMsg"
              :layout="layout"
              :page-sizes="[5, 10]"
              @sizeChange="pageSizeChange"
              @currentChange="currentPageChange"
            ></el-pageCover>
          </div>
        </div>
    </div>
</template>
<script>
import ElPageCover from "../../../components/overall/ElPageCover";
import { toChineseDate,dateTransfor1,dateTransfor } from "../../../utils/commons";
import { getEquipWarnResume,getEquipClearWarning} from "../../../utils/api";
    export default{
        data(){
            return{
             dataList: [
            ],
            listLoading:true,
            layout: " prev, pager, next, sizes, jumper , total",
            pageMsg: {
                pageSize: 10,
                pageNo: 1,
                totalRecords: 34,
                },
            maintaiSearch:'',    
            value1:['',''],
              pickerOptions: {
                shortcuts: [{
                  text: '最近一周',
                  onClick(picker) {
                      const end = new Date();
                      const start = new Date();
                      start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                      picker.$emit('pick', [start, end]);
                  }
                  }, {
                  text: '最近一个月',
                  onClick(picker) {
                      const end = new Date();
                      const start = new Date();
                      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                      picker.$emit('pick', [start, end]);
                  }
                  }, {
                  text: '最近三个月',
                  onClick(picker) {
                      const end = new Date();
                      const start = new Date();
                      start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                      picker.$emit('pick', [start, end]);
                  }
                  }],
                  disabledDate: (time) => {
                  return time.getTime() > Date.now();
                  }
              } 
            }
        },
        props: ["code","workIndex"],
        watch:{
            workIndex(val){
                if(val==3){
                    this.getEquipwarnTable();
                }
            },
            code(){
              this.reset()
            }
        },
        computed: {
          hasOperater(){
            return (content)=>{
              switch(content){
                // case '油位异常':
                //   return true
                case '水温异常':
                  return true
                case '机油压力低':
                  return true
                case '前方障碍物':
                  return true
                case '后方障碍物':
                  return true
                case '超出安全施工范围':
                  return true
                case '超速报警':
                  return true
                case '总油耗过高':
                  return true
                case '每小时油耗过高':
                  return true
                case '每小时油耗过低':
                  return true
                case '偷油':
                  return true
                case '开机时长过高':
                  return true
                case '开机时长过低':
                  return true
                case '行驶里程过高':
                  return true
                case '行驶里程过低':
                  return true 
              }
            }
          }
        },
        created() {
          this.value1=[dateTransfor1(),dateTransfor()]
        },
        mounted() {
          // this.getEquipwarnTable();
        },
        components:{ElPageCover},
        methods:{
          downAlarm(id){
            getEquipClearWarning({id:id}).then(res=>{
              if(res.data.code==200){
                this.$message({
                  type:'success',
                  message:'完成保养'
                })
                this.getEquipwarnTable();
              }
            })
          },
            pageSizeChange(size){
              this.pageMsg.pageSize = size;
              this.pageMsg.pageNo = 1;
              this.getEquipwarnTable();
          },
          currentPageChange(index){
              this.pageMsg.pageNo = index;
              this.getEquipwarnTable();
          },
          doSearch(){
            this.pageMsg.pageNo=1
            this.getEquipwarnTable();
          },
          reset(){
            this.pageMsg.pageNo=1
            this.maintaiSearch=''
            this.value1=[dateTransfor1(),dateTransfor()]
            this.getEquipwarnTable();
          },
           getEquipwarnTable(){
              this.listLoading=true;
              if(this.value1==null) this.value1=['','']
              let params={
                code:this.code,
                pageNo:this.pageMsg.pageNo,
                pageSize:this.pageMsg.pageSize,
                content:this.maintaiSearch,
                startTime:this.value1[0],
                endTime:this.value1[1]
              }
              getEquipWarnResume(params).then(res=>{
              const info=res.data.content.info;
              if(!info.pageSize){
                this.dataList=[];
                this.listLoading=false;
                this.pageMsg={
                pageNo:1,
                pageSize: 5,
                totalRecords: 0,
                };
                return 
              }
              this.pageMsg={
                pageNo:info.pageNo,
                pageSize: info.pageSize,
                totalRecords: info.totalRecords,
              };
              this.listLoading=false;
              this.dataList=info.list.map((item,index)=>{
                return {
                  id:item.id,
                  order:(info.pageNo-1)*info.pageSize+index+1,
                  warnCont: item.content,
                  startTime: item.startTime==null?'':toChineseDate(item.startTime+""),
                  endTime: item.endTime==null?'':toChineseDate(item.endTime+""),
                  duration: item.duration,
                  projectId: item.projectId,
                  // sectionName:item.relSection,
                  workId:item.workId,
                  location:item.address,
                  gps:item.gps,
                  status:item.status,
                  alarmId:item.alarmId
                  }
              });
            }) 
          },
        analysis(obj){
          switch(obj.warnCont){
                // case '油位异常':
                //   this.$emit('jumper',obj,'oil')
                // break;  
                case '水温异常':
                  this.$emit('jumper',obj,'inquiry')
                break; 
                case '机油压力低':
                  this.$emit('jumper',obj,'inquiry')
                break; 
                case '前方障碍物':
                  this.$emit('jumper',obj,'playback')
                break; 
                case '后方障碍物':
                  this.$emit('jumper',obj,'playback')
                break; 
                case '超出安全施工范围':
                  this.$emit('jumper',obj,'playback')
                break; 
                case '超速报警':
                  this.$emit('jumper',obj,'inquiry')
                break; 
                case '总油耗过高':
                  this.$emit('jumper',obj,'oiltotal')
                break; 
                case '每小时油耗过高':
                  this.$emit('jumper',obj,'oil')
                break; 
                case '每小时油耗过低':
                  this.$emit('jumper',obj,'oil')
                break; 
                case '偷油':
                  this.$emit('jumper',obj,'oil')
                break; 
                case '开机时长过高':
                  this.$emit('jumper',obj,'worktime')
                break; 
                case '开机时长过低':
                  this.$emit('jumper',obj,'worktime')
                break; 
                case '行驶里程过高':
                  this.$emit('jumper',obj,'mileage')
                break; 
                case '行驶里程过低':
                  this.$emit('jumper',obj,'mileage') 
                break;   
              }
        }
      }
    }
    
</script>
<style lang="scss" scoped="">
   .wrap{
       margin-top: 12px;
    .listContain3 {
            width: 100%;
            height: 595px;
            margin: 0 auto;
            position: relative;
            .pageblock {
            position: absolute;
            top: 632px;
            right: 20px;
            }
            .tablelistBody{
              height: 595px;
              .el-table .cell{
                  .alarmBtn{
                    background: #169BD5;
                    color: #FFFFFF;
                    width: 80px;
                    text-align: center;
                    border-radius: 5px;
                    cursor: pointer;
                  }
                  .analysis{
                    width: 70px;
                    height: 30px;
                    cursor: pointer;
                    color: #FFFFFF;
                    background: #E96B5A;
                    text-align: center;
                    line-height: 30px;
                    border-radius: 3px;
                  }
              }
            }
            .searchContent {
              height: 50px;
              width: 80%;
              padding: 5px 17px;
              display: flex;
              align-items: center;
              .oildataPicker{
                  .name{
                  font-size: 14px;
                  }
              }
            }
        }
   }
    
</style>
<style lang="scss">
  .listContain3 {
      .tablelistBody{
        .el-table{
          height: 598px !important;
          .el-table__body-wrapper{
            height: 604px !important;
          }
        }
        // overflow: auto;
      }
  }
</style>